import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import { useState } from "react"

import Column from "../../../common/components/Column"
import DialogHeader from "./DialogHeader"

export default function InsertLinkDialog({ open, onClose, editorRef }) {
  const [url, setURL] = useState("")
  const [text, setText] = useState("")

  function handleSoftClose() {
    onClose()
  }

  function handleInsertButtonClicked() {
    editorRef.current.insertContent(
      `<a href=${url} target="_blank">${text}</a>`
    )
    setURL("")
    setText("")
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Insert Link" onClose={handleSoftClose} />
      <DialogContent>
        <Column sx={{ gap: 2 }}>
          <TextField
            label="URL"
            value={url}
            onChange={(e) => setURL(e.target.value)}
            fullWidth
            type="url"
            required
            focused
          />
          <TextField
            label="Text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            fullWidth
            required
          />
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!url || !text}
          onClick={handleInsertButtonClicked}
        >
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  )
}
